import React, { useState,useEffect } from 'react'
import { Card, Col, Container, Row, Button, Input} from 'reactstrap'
import SwTeamCreatetask from './Components/SwTeamCreatetask'
import SWTeamTask from './Components/SWTeamTask'
import MyTasksDropdown from '../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksDropdown.svg';
import NewTaskIcon from '../../../../../src/designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg';
import MyTasksUpIcon from '../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksUpIcon.svg';
import MyTicketsUpIcon from '../../../../../src/designUtils/OpsDashboard/MyTasks/MyTicketsUpIcon.svg';
import MyWFUpIcon from '../../../../../src/designUtils/OpsDashboard/MyTasks/MyWFUpIcon.svg';
import MyTicketsDropdown from '../../../../../src/designUtils/OpsDashboard/MyTasks/MyTicketsDropdown.svg';
import MyWFDropdown from '../../../../../src/designUtils/OpsDashboard/MyTasks/MyWFDropdown.svg';
import { connect } from 'react-redux';
import PieChart from './Components/PieChart'
import { height } from '@fortawesome/free-solid-svg-icons/faWindowClose'
import CreateNewTask from './Components/SubComponentsSwTeamTask/CreateNewTask'
import NotiDropdownUp from '../../../../../src/designUtils/OpsDashboard/MyTasks/NotiDropdownUp.svg';
import NotiDropdown from '../../../../../src/designUtils/OpsDashboard/MyTasks/NotiDropdown.svg';
import Group from "./../../../../assets/img/StoreOverview_Img/Group.png";


import WorkflowsMainPage from '../Operations/Scenes/Workflows_v1/WorkflowsMainPage'
import OpsDashTicketListPage from '../Operations/Scenes/opsDashTickets/OpsDashTicketListPage';
import CustomModal from '../../../Components/Modals/CustomModal';
import getAllStatistics from '../../../../Service/OPSServices/SWInternalServices/getAllStatistics';
import GetAllTasksServices from '../../../../Service/OPSServices/SWInternalServices/GetAllTasksServices';
import GetUserProfileDataService from '../../../../Service/DashboardServices/UserProfileServices/ProfileDataServices/GetUserProfileDataService';
import { faLiraSign } from '@fortawesome/free-solid-svg-icons';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'react-loaders';
import NotificationsMainFile from '../StoreOverview_v1/Scenes/Components/PartnerUpdateLog/NotificationsMainFile';
import DashbordTicketListPage_v1 from '../DashboardTicketList_v1/DashbordTicketListPage_v1';
import SWTeamRolesCard from '../Operations/Scenes/Account Details/Component/SubComponents/SWTeamRolesCard';
import FetchStoreUserRoleMappingDataService from '../../../../Service/OPSServices/AccountDetailsService/FetchStoreUserRoleMappingDataService';
import CreateNewTicketFromDash from './Components/SubComponentsSwTeamTask/CreateNewTicketFromDash';

function MyTasksMainPage(props) {
  const [tabs, setTabs] = useState(3)
  const [myTaskIcons,setMyTaskIcons]= useState(true)
  const [ticketIcons,setTicketIcons]= useState(false)
  const [workflowsIcons,setWorkflowsIcons]= useState(false)
  const [createNewTaskPopup,setCreateNewTaskPopup]= useState(false)
  const [taskList, setTaskList] = useState([])
  const [teamMemberList, setTeamMemberList] = useState('')
  const [allStats, setallStats] = useState()
  const [cardTitle, setCardTitle] = useState();
  const[notificationIcons,setNotificationIcons]= useState(false)
  const [agencyMemberList, setAgencyMemberList] = useState('')
  const [LoggedUserRole,setloggedUserRole] = useState()
  const [notificationsDetails,setNotificationsDetails]=useState({
    tabs: props.globalPermissions &&props.globalPermissions.Dashboard_Tasks?3 :4,
    details:'',
    action:'',
    searchparams:''
  })


  const [loggedUserId , setloggedUserId] = useState()
  const [taskCount , setTaskCount] = useState(0)
  const [worflowCount,setworflowCount]= useState(0)
  const [ticketCount,setticketCount]= useState(0)
  const [taskStatus, setTaskStatus] = useState()
  const [loading,setloading]= useState(false)

  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
  });
  const [statusNames, setstatusName] = useState([])
  const [statusColor, setstatusColor] = useState([])
  const [statusCount, setstatusCount] = useState([])
  const [notiCount, setNotiCount] = useState('0');
  const [selectedStore, setSelectedStore] = useState(""); 
  const [store, setStore] = useState(0);
  // Accounts related states
  const [swTeamRolesPopup, setSwTeamRolesPopup] = useState(false);
  const [mappingTable, setMappingTable] = useState([]);
  const [memberDropdown, setMemberDropdown] = useState([]);
  const [createNewTicketPopUp,setCreateNewTicketPopUp]= useState(false);


  useEffect(() => {
    console.log(store)
    // if (props.accessLevel !== 5 && store === 0) return;
    const fetchData = () => {
    // setloading(true)
    let data=  { intId: store && store.integerID ? store.integerID : 0 };
    getAllStatistics(props.token,data).then((res) => {
      if (res) {
        console.log(res);
        setNotiCount(res.notiCount);
        console.log(res.taskStatistics);
        console.log(res.taskStatistics.map((item) => item.status));
        setallStats(res)
        setTaskCount(res.taskStatistics[0].count)
        setworflowCount(res.workflowStatistics[0].count)
        setticketCount(res.ticketStatistics[0].count)
        let currentStats = res.taskStatistics; 

    if (notificationsDetails.tabs === 1) {
      currentStats = res.workflowStatistics;
    } else if (notificationsDetails.tabs === 2) {
      currentStats = res.ticketStatistics;
    } else if (notificationsDetails.tabs === 3) {
      currentStats = res.taskStatistics;
    }

    if (currentStats) {
      setstatusName(currentStats.filter((item) => item.status !== 'Open').map((item) => item.status));
      setstatusColor(currentStats.filter((item) => item.status !== 'Open').map((item) => item.color));
      setstatusCount(currentStats.filter((item) => item.status !== 'Open').map((item) => item.count));
    }
  }
})
    console.log(statusNames);
    {props.globalPermissions &&props.globalPermissions.Dashboard_Tasks &&
    GetAllTasksServices(props.token,data).then((responce) => {
      if (responce) {
        console.log('responce')
        console.log(responce)
        setloggedUserId(responce.loggedUserId)
        setTaskList(responce.tasklist)
        setloggedUserRole(responce.loggedUserRole)
        setAgencyMemberList(responce.agencyMember)
        setTeamMemberList(responce.teamMembers)
        setTaskStatus(responce.statusList)
        setloading(false)
        // setTaskStatus(responce.statusList)
        // const statusName = responce.statusList.map(item => item.status);
        // setstatusName(statusName)
        // const tasks = responce.tasklist.filter((task) => task.status != 'Completed' && task.assignedTo == responce.loggedUserId);
        // setTaskCount(tasks.length)
      }
    })}
    GetUserProfileDataService(props.token).then((response) => {
      if (response) {
        console.log(response);
        setUserData({
          firstName: response.firstName,
          lastName: response.lastName,
          email: response.email,
          phone: response.phone,
          companyName: response.companyName,
        })
      }
    })

}

handleTimeDate()
fetchData(); 
}, [store]); 


  const handleChangeTabs = (value) => {
    if (value === 1) {
      setCardTitle("Workflow Tasks");
      setstatusName(allStats &&allStats.workflowStatistics.filter((item) => item.status !== 'Open').map((item)=>item.status))
      setstatusColor(allStats &&allStats.workflowStatistics.filter((item) => item.status !== 'Open').map((item)=>item.color))
      setstatusCount(allStats &&allStats.workflowStatistics.filter((item) => item.status !== 'Open').map((item)=>item.count))
      setWorkflowsIcons(!workflowsIcons)
      setTicketIcons(false)
      setMyTaskIcons(false)
      setNotificationIcons(false)

    }
    if (value === 2) {
      setCardTitle("Tickets");
      setstatusName(allStats &&allStats.ticketStatistics.filter((item) => item.status !== 'Open').map((item) => item.status))
      setstatusColor(allStats &&allStats.ticketStatistics.filter((item) => item.status !== 'Open').map((item) => item.color))
      setstatusCount(allStats &&allStats.ticketStatistics.filter((item) => item.status !== 'Open').map((item) => item.count))
      setTicketIcons(!ticketIcons)
      setMyTaskIcons(false)
      setWorkflowsIcons(false)
      setNotificationIcons(false)

    }
    if (value === 3) {
      setCardTitle("My Tasks");
      setstatusName(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.status))
      setstatusColor(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.color))
      setstatusCount(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.count))
      setMyTaskIcons(!myTaskIcons)
      setWorkflowsIcons(false)
      setTicketIcons(false)
      setNotificationIcons(false)
    }
    if (value === 4) {
      setCardTitle("My Notification");
      // setstatusName(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.status))
      // setstatusColor(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.color))
      // setstatusCount(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.count))
      setNotificationIcons(!notificationIcons)
      setWorkflowsIcons(false)
      setTicketIcons(false)
      setMyTaskIcons(false)


    }
    // setMyTaskIcons(value, !myTaskIcons)
    // setShowTabsUi(!showTabsUi)
    // setTabs(value)
    setNotificationsDetails({
      tabs: value,
      details:'',
      action:false,
      searchparams:''
    })
  }
  const handleCreateTaskPopup = () => {

    setCreateNewTaskPopup(true)
  }
  const createNewTicket=()=>{
    if (!selectedStore) return;
    setCreateNewTicketPopUp(true)
  }
  const handleCloseCreateTicketPopup = () => {
    setCreateNewTicketPopUp(false)
  }
  const handleCloseCreateTaskPopup = (task) => {
    setCreateNewTaskPopup(false)
    setTaskList(task)
  
    let data = {
      intId: store ? store.integerID : 0
    }
  
    getAllStatistics(props.token, data).then((res) => {
      if (res) {
        setTaskCount(res.taskStatistics[0].count);
      
        setstatusCount(
          res.taskStatistics
            .filter((item) => item.status !== "Open")
            .map((item) => item.count)
        );
      }
    })
  }
  const [currentTime, setCurrentTime] = useState(new Date());
  const handleTimeDate = () => {
    setCurrentTime(new Date());

  }

  const formattedDate = currentTime.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const formattedTime = currentTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const handleStoreChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedStore(selectedValue);
  
    if (selectedValue === "") {
      setStore({ integerID: 0, name: "All Stores", logo: null }); 
    } else {
      const selectedStoreObj = props.adProfiles.find((profile) => profile.integerID.toString() === selectedValue);
      setStore(selectedStoreObj || { integerID: 0, name: "All Stores", logo: null }); 
    }
  };

  function handleClickViewAnalytic() {
    alert("Development for this functionality is in progress.");
  }
  const handleRoleSettingPopup=()=>{
    let data={ id: 0,integerId:selectedStore }
    FetchStoreUserRoleMappingDataService(props.token,data).then((res) => {
      if (res) {
        setSwTeamRolesPopup(true)
        console.log(res)
        setMappingTable(res.tableData);
        setMemberDropdown(res.memberDropdown);
      }
    });
    
  }

  return (
    <Col className='mt-5 pt-4'>
      <Row>
        <Col md={9}>
          <Row>
            <Col md={12}>
              <h5>
                <b>Hello, {userData.firstName}</b>
              </h5>
              <h6> <b>{`${formattedDate}, ${formattedTime}`}</b></h6>
              <div className="mt-3 mb-3">
              {props.accessLevel !== 5 ?
                (<div>
                  <div className="d-flex align-items-center mb-2 ml-1">
                    <p className="text-center mb-0 mr-2">
                      <img
                         src={store && store.logo ? store.logo : Group}
                         width={store && store.logo ? "" : 30}
                        alt="Store Logo"
                        style={{ opacity: selectedStore ? 1 : 0.3 }} 
                      />
                    </p>
                    <h6 className="mb-0 text-truncate">
                    <b>{selectedStore && store ? store.name : "No Store"}</b>
                    </h6>
                  </div>
                  <div className="d-flex align-items-center">
                  <div className="px-1">
                    <select
                      id="StoreList"
                      name="StoreList"
                      onChange={handleStoreChange}
                      value={selectedStore}
                      className="form-control form-control-sm w-100"
                    >
                      <option value="">--Select Store (All) --</option> 
                      {props.adProfiles && props.adProfiles.length > 0
                        ? props.adProfiles.map((s) => (
                          <option key={s.integerID} value={s.integerID}>
                            {s.name} ({s.location})
                          </option>
                        ))
                        : null}
                    </select>
                  </div>
                  {props.accessLevel === 0 ?
                  <Button
                      className="ml-3 mb-1 btn-background-color"
                      onClick={() => handleRoleSettingPopup()}
                      disabled={!selectedStore}
                    >
                      SW Team Roles
                    </Button>:''}
                    </div>
                </div>
                ) : null}
                </div>
              <div className='d-flex mt-4 mb-3' >
                {/* <div className='d-flex justify-content-center message-color 'onClick={handleClickViewAnalytic}>
                  <h6 className='font-color-heading  mr-2 mt-2' ><b>Messages</b> </h6>
                </div> */}
              { props.globalPermissions && props.globalPermissions.Dashboard_NewTask ? 

              <div className='new-task-color mr-3' onClick={handleCreateTaskPopup}>
                <h6 className='font-color-heading  mt-2' ><b>New Task </b> <img className='ml-3 mb-1'  src={NewTaskIcon} /></h6>
              </div>:''}
              { props.globalPermissions && props.globalPermissions.Dashboard_NewTask ? 

                <div
                className={`new-ticket-color ${!selectedStore ? "disabled-div" : ""}`}
                onClick={selectedStore ? createNewTicket : undefined}
                >
                <h6 className="font-color-heading mt-2">
                  <b>New Ticket</b>
                  <img className="ml-3 mb-1" src={NewTaskIcon} alt="New Ticket" />
                </h6>
                </div>:''}

              </div>
            </Col>
            { props.globalPermissions && props.globalPermissions.Dashboard_Tasks ? 
            <Col md={3}>
              <Card
                onClick={() => { handleChangeTabs(3) }}
                className={`p-4 card-of-problemarea swteam-tasks mt-3`}>
                <h6
                  style={{ color: '#243837' }}
                >
                  <b>Tasks</b></h6>
                <div className="d-flex justify-content-between">
                  <h6 style={{ color: '#243837' }}><b>{taskCount}</b></h6>

                  <img
                    src={myTaskIcons ? MyTasksUpIcon :  MyTasksDropdown} />
                </div>
              </Card>
            </Col>:''}
            { props.globalPermissions && props.globalPermissions.Dashboard_Notifications ? 
            <Col md={3}>
              <Card
                onClick={() => { handleChangeTabs(4) }}
               className={`p-4 card-of-problemarea notification-tasks mt-3`}>
                <h6
                style={{color: '#243837' }}>
                  <b>Notifications</b>
                </h6>
                <div className="d-flex justify-content-between">
                <h6 style={{ color: '#243837' }}><b>{notiCount}</b></h6>
                <img src={notificationIcons ? NotiDropdownUp:  NotiDropdown } />
                </div>
              </Card>
            </Col>:""}
           
            { props.globalPermissions && props.globalPermissions.Dashboard_Tickets ? 
            <Col md={3}>
              <Card
                onClick={() => { handleChangeTabs(2) }}
                className={`p-4 card-of-problemarea ticket-tasks mt-3`} >
                <h6
                  style={{ color: '#243837' }}
                >
                  <b>Tickets</b></h6>
                <div className="d-flex justify-content-between">
                  <h6 style={{ color: '#243837' }}><b>{ticketCount}</b></h6>

                  <img src={ticketIcons ?  MyTicketsUpIcon:  MyTicketsDropdown} alt="Dropdown Icon" />
                </div>
              </Card>
              </Col>:''}
              { props.globalPermissions && props.globalPermissions.Dashboard_Workflows ? 
               <Col md={3}>
               <Card className={`p-4 card-of-problemarea workflow-tasks mt-3`}
                 onClick={() => { handleChangeTabs(1) }} >
                 <h6
                   style={{ color: '#243837' }}
                 >
                   <b>Workflows
                     </b></h6>
                 <div className="d-flex justify-content-between">
                   <h6 style={{ color: '#243837' }}><b>{worflowCount}</b></h6>
                   <img src={workflowsIcons ? MyWFUpIcon:  MyWFDropdown } />
                 </div>
               </Card>
             </Col>:''
              }
             
          </Row>

        </Col>
        {notificationsDetails.tabs!==4 &&
        <Col md={3}>
        <Card className='card-of-problemarea p-2' style={{ height: '275px' }}>
          <div className='custom-task-overview'>
            <h5 className='text-center'><b>{cardTitle?cardTitle:"My Tasks"}</b></h5></div>
          {/* <h6 className='text-center'><b>Nov 2024</b></h6>    */}
          <PieChart Status={statusNames} count={statusCount} color={statusColor} />
        </Card>
      </Col>


        }
        
        <Col md={12}>
        <LoadingOverlay
          active={loading}
          styles={{
            overlay: (base) => ({
              ...base,
              background: '#f1f4f6',
              opacity: 1,
            }),
            content: (base) => ({
              ...base,
              color: '#000',
            }),
          }}
          spinner={<Loader active type="ball-pulse" />}
          text='Loading your Tasks...'
      >
          {
            (notificationsDetails.tabs === 1) ? //Workflows component
              <WorkflowsMainPage isMyworksScreen={true}
              store={store} setStore={setStore}
              notificationsDetails={notificationsDetails}
              setNotificationsDetails={setNotificationsDetails} /> :
              (notificationsDetails.tabs === 2) ? //TicketList component
              (LoggedUserRole==2 ||LoggedUserRole==22 || LoggedUserRole==6?
                <DashbordTicketListPage_v1  //2- Partner , 6-Agency Client, 22- store manager
                notificationsDetails={notificationsDetails}
              setNotificationsDetails={setNotificationsDetails}
              store={store} setStore={setStore}
              isMyworksScreen={true}
                />:   
              (<OpsDashTicketListPage isMyworksScreen={true} 
              // dashDtore={store} setDashStore={setStore}
              dashDtore={store && store.integerID ? store : 0}  setDashStore={setStore}
              notificationsDetails={notificationsDetails}
              setNotificationsDetails={setNotificationsDetails}/> )):
                (notificationsDetails.tabs===4)? //Notifications component
                 <NotificationsMainFile isMyworksScreen={true}
                 searchparams={''}
              store={store} setStore={setStore}
              notificationsDetails={notificationsDetails}
                setNotificationsDetails={setNotificationsDetails}/>:
                (notificationsDetails.tabs === 3) ? //task component
                  <SWTeamTask  
                  LoggedUserRole={LoggedUserRole}
                  store={store} setStore={setStore}

                  setAgencyMemberList={setAgencyMemberList}
                  agencyMemberList={agencyMemberList}

                  setloading={setloading}
                  notificationsDetails={notificationsDetails}
                  setNotificationsDetails={setNotificationsDetails}
                  setstatusCount={setstatusCount}
                  setTaskStatus={setTaskStatus}
                  taskStatus={taskStatus}
                  loggedUserId={loggedUserId}
                  setTaskList={setTaskList}
                  taskList={taskList}
                  userData ={userData}
                  teamMemberList={teamMemberList}
                  setTeamMemberList={setTeamMemberList}/> : ''
            // <SwTeamCreatetask/>:''
          }
          </LoadingOverlay>
        </Col>
      </Row>
      <CustomModal
        header={"Create New Task"}
        isOpen={createNewTaskPopup}
        toggle={() => setCreateNewTaskPopup(!createNewTaskPopup)}
        size={"xl"}
        className='my-task-custom-module'
      >
          <Card className='card-of-problemarea'>
          <CreateNewTask
           setAgencyMemberList={setAgencyMemberList}
           agencyMemberList={agencyMemberList}
              store={store} setStore={setStore}
              loggedUserId={loggedUserId}
            teamMemberList={teamMemberList}
            taskList={taskList}
            setTaskCount={setTaskCount}
            taskCount={taskCount}
            setstatusCount={setstatusCount}
            handleCloseCreateTaskPopup={handleCloseCreateTaskPopup}
          />
        </Card>
      </CustomModal>
      <CustomModal
        header={"Create New Ticket"}
        isOpen={createNewTicketPopUp}
        toggle={() => setCreateNewTicketPopUp(!createNewTicketPopUp)}
        size={"xl"}
        className='my-task-custom-module'
      >
          <Card className='card-of-problemarea'>
          <CreateNewTicketFromDash
              store={store}
              setStore={setStore}
              handleCloseCreateTicketPopup={handleCloseCreateTicketPopup}
          />
        </Card>
      </CustomModal>
      <CustomModal
        header={
          props.selectedStore && props.adProfiles
            ? (() => {
                const matchedStore = props.adProfiles.find(
                  (store) => String(store.integerID) === String(props.selectedStore)
                );
                return matchedStore ? `SW Team Roles : ${matchedStore.name}` : "SW Team Roles";
              })()
            : "SW Team Roles"
        }
        isOpen={swTeamRolesPopup}
        toggle={() => setSwTeamRolesPopup(!swTeamRolesPopup)}
        size={"lg"}
        className=' curve-popup my-task-custom-module'
      >
          <SWTeamRolesCard
            mappingTable={mappingTable} 
            setMappingTable={setMappingTable}
            setMemberDropdown={setMemberDropdown}
            memberDropdown={memberDropdown}
            isModal={true}
          />
      </CustomModal>
    </Col>
  )
}

const mapStateToProps = state => {
  return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
      globalPermissions: state.loggedUser.globalPermissions,
      adProfiles: state.accountOverview.landing.adProfiles,
  }
}

export default connect(mapStateToProps)(MyTasksMainPage);
